/*
包含n个基于state的getter计算属性方法的对象模块
 */
export default {
   //判断传入菜单英文名称是在用户权限菜单数组中
   hasMenuEnName: (state, getters) => (menuEnName) => {
      let result 
      //如果是super,忽略权限判断
      console.log(state.user)
      if (state.user.auth === 'super') {
        result = true
      } else {
         //使用jquery判断是否存在菜单
         let index = $.inArray(menuEnName, state.user.menuEnNames)
         result = index === -1 ? false : true
      }
      
     return result
   },
   //获取当前区域编码
   getUserInfo: (state, getters) => () => {
     let result = state.user
     return result
   },
   
   getCurAreaCode: (state, getters) => () => {
    let result = state.currAreaCode
    return result
  },
   //根据区域编码判断是否应该显示
   isShow: (state, getters) => (menuId) => {
    
    let result = false
      
      //当前用登录用户信息
      let userInfo = state.user
     
      if (userInfo.auth == 'super') {
        result = true
        return result
      } 
    

      let adminMenu = [  '1',
                            '2', '2-1', '2-2',
                            '3','5',
                            '4', '4-1', '4-2', '4-3',
                            '7', 
                            '8',
                            '11'
                         ]
               //操作者
      let Menu = [    '1',
                      '2', '2-1', '2-2',
                      '3', '3-1', '3-2','5',
                      '4', '4-1', '4-2', '4-3',
                      '7'
                      ]
            
      
      //管理员
      if (userInfo.auth == 'admin'&& adminMenu.indexOf(menuId) != -1) {
       
        return true
      }
     
      //操作者
      if (userInfo.auth =='handlers' && Menu.indexOf(menuId) != -1) {

        return true
      }

      
      return result
   },
   getTomcatInfo: (state, getters) => () => {
     let result = state.tomcatInfo
     return result
   },

}


// WEBPACK FOOTER //
// ./src/vuex/getters.js